import { Content } from '~/styles/home'

export default function HomePage() {
  return (
    <Content>
      <h2 style={{ color: 'white' }}>Home page content</h2>
    </Content>
  )
}
